import { EXPENSE_TYPE, FREQUENCY } from '@funnels/constants';

import { SERVER_EXPENSES1, SERVER_EXPENSES2, SERVER_EXPENSES3 } from '../serverData';

export const EXPENSES_HAVE_GROUP_OTHER_DATA = {
  ...SERVER_EXPENSES3,
  expenses: [
    ...SERVER_EXPENSES3.expenses,
    {
      type: EXPENSE_TYPE.CHILD_AND_SPOUSAL_MAINTENANCE,
      amount: 600,
      frequency: FREQUENCY.MONTHLY,
      comments: 'no comments',
    },
    {
      type: EXPENSE_TYPE.RENT,
      amount: 2000,
      frequency: FREQUENCY.MONTHLY,
      comments: 'no comments',
    },
  ],
};

export const EXPENSES_MARRIED_APPLICANT_ONE = {
  ...SERVER_EXPENSES1,
  expenses: [
    ...SERVER_EXPENSES1.expenses,
    {
      type: EXPENSE_TYPE.CHILD_AND_SPOUSAL_MAINTENANCE,
      amount: 600,
      frequency: FREQUENCY.MONTHLY,
      comments: 'no comments',
    },
  ],
};

export const EXPENSES_MARRIED_APPLICANT_TWO = {
  ...SERVER_EXPENSES2,
};
